import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=ee5038e4&scoped=true&"
import script from "./payments.ts?vue&type=script&lang=ts&"
export * from "./payments.ts?vue&type=script&lang=ts&"
import style0 from "./payments.scss?vue&type=style&index=0&id=ee5038e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5038e4",
  null
  
)

export default component.exports